import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { useBusinessUnit } from "@/context/BusinessUnitContext";

export default function ProtectedRoute({ children, roles, requireBusinessUnit = true }) {
  const { user, loading } = useAuth();
  const { businessUnit } = useBusinessUnit();
  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen text-zinc-500 font-mono text-xs">
        LOADING...
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) {
    return (
      <div className="flex items-center justify-center h-screen text-zinc-700 text-sm">
        Access denied for role: <span className="ml-2 font-mono uppercase">{user.role}</span>
      </div>
    );
  }
  // Force a vertical choice before letting the user into tenant-scoped screens.
  // Certain screens (like /select-vertical itself) opt out via requireBusinessUnit=false.
  if (requireBusinessUnit && !businessUnit) {
    return <Navigate to="/select-vertical" replace />;
  }
  return children;
}
